import FormDivider from 'omakase/FormBlock/FormDivider';
import FormHeading from 'omakase/FormBlock/FormHeading';
import FormSection from 'omakase/FormBlock/FormSection';
import React, { FunctionComponent } from 'react';

export interface FormBlockProps {
  /**
   * Optional text to populate the title of the form block.
   */
  titleText?: React.ReactNode;
  /**
   * Optional text to populate paragraph text below the title.
   */
  paragraphText?: string;
  /**
   * Whether to show or hide the divider. If left undefined, default behavior is as though "true" were specified.
   */
  showDivider?: boolean;
  /**
   * Whether the form block has background of surface-02 (otherwise, surface-01)
   */
  background?: boolean;
  /**
   * Whether the form block renders desktop content with a "box" border
   */
  box?: boolean;
  /**
   * Whether the form block is nested within another form block (removes padding for the nested block)
   */
  nested?: boolean;
  className?: string;
}

const FormBlock: FunctionComponent<FormBlockProps> = ({
  titleText,
  paragraphText,
  children,
  nested = false,
  showDivider = !nested,
  background = false,
  box = false,
  ...rest
}) => (
  <>
    <FormSection nested={nested} background={background} box={box} {...rest}>
      {(titleText || paragraphText) && <FormHeading title={titleText} subtitle={paragraphText} />}
      {children}
    </FormSection>
    {showDivider && <FormDivider mobileOnly={box} />}
  </>
);

export default FormBlock;
